export default __webpack_public_path__ + "static/media/dragon.79d1189e.png";